module.exports = "/_next/static/images/iso-ie-dfd00796725798cec58524d449d14d45.png";